<template>
  <div class="orderInfo-container">
    <v-header title="订单详情"></v-header>
    <el-page-header @back="goBack" content="订单管理">
    </el-page-header>
    <div class="container" v-loading="loading" element-loading-text="数据加载中"
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">

      <!--基本信息-->
      <el-collapse v-model="activeBaseInfo">
        <el-collapse-item title="基本信息" name="1">
          <el-table
            :data="baseInfoData"
            border
            stripe="true"
            style="width: calc(100% - 30px);margin: 0 auto;margin-top: 15px">
            <el-table-column
              align="center"
              prop="orderNo"
              show-overflow-tooltip="true"
              label="订单号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="companyCode"
              show-overflow-tooltip="true"
              label="经代公司">
            </el-table-column>
            <el-table-column
              align="center"
              prop="ecobranchId"
              show-overflow-tooltip="true"
              label="分公司">
            </el-table-column>
            <el-table-column
              align="center"
              prop="adPsnname"
              show-overflow-tooltip="true"
              label="销售人员姓名">
            </el-table-column>
            <el-table-column
              align="center"
              prop="pcardid"
              show-overflow-tooltip="true"
              label="销售人员编码">
            </el-table-column>
            <el-table-column
              align="center"
              prop="orderStatus"
              show-overflow-tooltip="true"
              label="订单状态">
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

      <!--保单信息-->
      <el-collapse v-model="activeOrderInfo">
        <el-collapse-item title="保单信息" name="1">
          <el-table
            :data="orderInfoData"
            border
            stripe="true"
            style="width: calc(100% - 30px);margin: 0 auto;margin-top: 15px">
            <el-table-column
              align="center"
              prop="contNo"
              show-overflow-tooltip="true"
              label="保单号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="prtNo"
              show-overflow-tooltip="true"
              label="投保单号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="partner"
              show-overflow-tooltip="true"
              label="渠道名称">
            </el-table-column>
            <el-table-column
              align="center"
              prop="beginDate"
              show-overflow-tooltip="true"
              label="投保日期">
            </el-table-column>
            <el-table-column
              align="center"
              prop="acceptTime"
              show-overflow-tooltip="true"
              label="生效日期">
            </el-table-column>
            <el-table-column
              align="center"
              prop="orderStatus"
              show-overflow-tooltip="true"
              label="保单状态">
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

      <!--险种信息-->
      <el-collapse v-model="activeInsuranceInfo">
        <el-collapse-item title="险种信息" name="1">
          <el-table
            :data="insuranceInfoData"
            border
            stripe="true"
            style="width: calc(100% - 30px);margin: 0 auto;margin-top: 15px">
            <el-table-column
              align="center"
              prop="productName"
              show-overflow-tooltip="true"
              label="产品名称">
            </el-table-column>
            <el-table-column
              align="center"
              prop="totalPremium"
              show-overflow-tooltip="true"
              label="总保费">
            </el-table-column>
            <el-table-column
              align="center"
              prop="insuranceAmount"
              show-overflow-tooltip="true"
              label="保额">
            </el-table-column>
            <el-table-column
              align="center"
              prop="totalCount"
              show-overflow-tooltip="true"
              label="购买份数">
            </el-table-column>
            <el-table-column
              align="center"
              prop="insurancePeriod"
              show-overflow-tooltip="true"
              label="保障期间">
            </el-table-column>
            <el-table-column
              align="center"
              prop="insurancePeriodType"
              show-overflow-tooltip="true"
              label="保障期间单位">
            </el-table-column>
            <el-table-column
              align="center"
              prop="payPeriod"
              show-overflow-tooltip="true"
              label="缴费期间">
            </el-table-column>
            <el-table-column
              align="center"
              prop="payPeriodType"
              show-overflow-tooltip="true"
              label="缴费期间单位">
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

      <!--支付信息-->
      <el-collapse v-model="activePaymentInfo">
        <el-collapse-item title="支付信息" name="1">
          <el-table
            :data="paymentInfoData"
            border
            stripe="true"
            style="width: calc(100% - 30px);margin: 0 auto;margin-top: 15px">
            <el-table-column
              align="center"
              prop="bankCardNo"
              show-overflow-tooltip="true"
              label="银行账号">
            </el-table-column>
            <el-table-column
              align="center"
              prop="bankCode"
              show-overflow-tooltip="true"
              label="开户行">
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

      <!--投保人信息-->
      <el-collapse v-model="activeHolderInfo">
        <el-collapse-item title="投保人信息" name="1">
          <el-table
            :data="holderInfoData"
            border
            stripe="true"
            style="width: calc(100% - 30px);margin: 0 auto;margin-top: 15px">
            <el-table-column
              align="center"
              prop="name"
              show-overflow-tooltip="true"
              label="姓名">
            </el-table-column>
            <el-table-column
              align="center"
              prop="sex"
              show-overflow-tooltip="true"
              label="性别">
            </el-table-column>
            <el-table-column
              align="center"
              prop="cardType"
              show-overflow-tooltip="true"
              label="证件类型">
            </el-table-column>
            <el-table-column
              align="center"
              prop="cardNo"
              show-overflow-tooltip="true"
              label="证件号码">
            </el-table-column>
            <el-table-column
              align="center"
              prop="cardEndDate"
              show-overflow-tooltip="true"
              label="证件有效期">
            </el-table-column>
            <el-table-column
              align="center"
              prop="birthday"
              show-overflow-tooltip="true"
              label="出生日期">
            </el-table-column>
            <el-table-column
              align="center"
              prop="mobile"
              show-overflow-tooltip="true"
              label="手机号码">
            </el-table-column>
            <el-table-column
              align="center"
              prop="email"
              show-overflow-tooltip="true"
              label="邮箱">
            </el-table-column>
            <el-table-column
              align="center"
              prop="province"
              show-overflow-tooltip="true"
              label="省">
            </el-table-column>
            <el-table-column
              align="center"
              prop="city"
              show-overflow-tooltip="true"
              label="市">
            </el-table-column>
            <el-table-column
              align="center"
              prop="address"
              show-overflow-tooltip="true"
              label="详细地址">
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

      <!--被保人信息-->
      <el-collapse v-model="activeInsuredInfo">
        <el-collapse-item title="被保人信息" name="1">
          <el-table
            :data="insuredInfoData"
            border
            stripe="true"
            style="width: calc(100% - 30px);margin: 0 auto;margin-top: 15px">
            <el-table-column
              align="center"
              prop="relationToHolder"
              show-overflow-tooltip="true"
              label="与投保人关系">
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              show-overflow-tooltip="true"
              label="姓名">
            </el-table-column>
            <el-table-column
              align="center"
              prop="sex"
              show-overflow-tooltip="true"
              label="性别">
            </el-table-column>
            <el-table-column
              align="center"
              prop="cardType"
              show-overflow-tooltip="true"
              label="证件类型">
            </el-table-column>
            <el-table-column
              align="center"
              prop="cardNo"
              show-overflow-tooltip="true"
              label="证件号码">
            </el-table-column>
            <el-table-column
              align="center"
              prop="cardEndDate"
              show-overflow-tooltip="true"
              label="证件有效期">
            </el-table-column>
            <el-table-column
              align="center"
              prop="birthday"
              show-overflow-tooltip="true"
              label="出生日期">
            </el-table-column>
            <el-table-column
              align="center"
              prop="mobile"
              show-overflow-tooltip="true"
              label="手机号码">
            </el-table-column>
            <el-table-column
              align="center"
              prop="email"
              show-overflow-tooltip="true"
              label="邮箱">
            </el-table-column>
            <el-table-column
              align="center"
              prop="province"
              show-overflow-tooltip="true"
              label="省">
            </el-table-column>
            <el-table-column
              align="center"
              prop="city"
              show-overflow-tooltip="true"
              label="市">
            </el-table-column>
            <el-table-column
              align="center"
              prop="address"
              show-overflow-tooltip="true"
              label="详细地址">
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

    </div>
  </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'

export default {
  name: 'orderInfo',
  components: {vHeader},
  data() {
    return {
      activeBaseInfo: ['1'], // 设置基本信息折叠面板默认打开
      activeOrderInfo: ['1'], // 设置保单信息折叠面板默认打开
      activeInsuranceInfo: ['1'], // 设置险种信息折叠面板默认打开
      activePaymentInfo: ['1'], // 设置支付信息折叠面板默认打开
      activeHolderInfo: ['1'], // 设置投保人信息折叠面板默认打开
      activeInsuredInfo: ['1'], // 设置被保人信息折叠面板默认打开
      baseInfoData: [], // 存储基本信息的数据集合
      orderInfoData: [], // 存储保单信息的数据集合
      insuranceInfoData: [], // 存储险种信息的数据集合
      paymentInfoData: [], // 存储支付信息的数据集合
      holderInfoData: [], // 存储投保人信息的数据集合
      insuredInfoData: [], // 存储被保人信息的数据集合
      loading: false // 设置是否开启加载遮罩的变量
    }
  },
  activated() {
    // 调用查询订单详情数据的方法
    this.getOrderInfoDataFunc()
  },
  methods: {
    /**
     * @Description: 查询订单详情数据的方法
     * @author:zhangqi
     * @Date:2021-12-02
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * @Description: 查询订单详情数据的方法
     * @author:zhangqi
     * @Date:2021-12-02
     */
    getOrderInfoDataFunc() {
      // 开启加载遮罩
      this.loading = true
      // 定义参数格式
      let param = {
        'orderNo': this.$route.query.orderNo
      }
      // 调用查询数据的接口，获取数据
      api.post(url.getOrderInfo, param, res => {
        if (res.header.isSuccess) {
          // 将获取到的基本信息数据赋值给对应的存储基本信息的数据集合
          this.baseInfoData = res.data.normal
          // 将获取到的保单信息数据赋值给对应的存储保单信息的数据集合
          this.orderInfoData = res.data.order
          // 将获取到的险种信息数据赋值给对应的存储险种信息的数据集合
          this.insuranceInfoData = res.data.insurance
          // 将获取到的支付信息数据赋值给对应的存储账户信息的数据集合
          this.paymentInfoData = res.data.payment
          // 将获取到的投保人信息数据赋值给对应的存储投保人信息的数据集合
          this.holderInfoData = res.data.holderInfo
          // 将获取到的被保人信息数据赋值给对应的存储被保人信息的数据集合
          this.insuredInfoData = res.data.insuredInfo
        } else {
          this.$message({
            type: 'error',
            message: res.error
          });
        }
        // 关闭表格加载遮罩层
        this.loading = false
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.orderInfo-container {
  .headercom {
    position: relative;
  }

  /deep/ .el-page-header {
    background: #FFFFFF;
    height: 35px;
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    display: flex;
    align-items: center;

    .el-page-header__left {
      padding-left: 15px;
    }

    .el-page-header__content {
      font-size: 16px;
    }
  }

  .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    height: calc(100vh - 150px);
    overflow-y: auto;
  }

  /deep/ .el-collapse {
    border-bottom: 0px;

    .el-collapse-item {
      margin-bottom: 15px;

      .el-collapse-item__header {
        font-size: 16px;
        font-weight: bold;
        padding-left: 15px;
        border-bottom-color: #EBEEF5
      }
    }

    thead {
      .el-table__cell {
        background: #F5F7FA;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/orderInfo.vue